import styled from 'styled-components';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export const TagTypeTitle = styled.p`
    font-weight: 600;
    font-size: 11px;
    line-height: 16px;
    margin-bottom: 8px;
`;

export const TagErrorWrapper = styled.div`
    display: flex;
    padding: 2px 8px 6px 8px;
    width: 164px;
    background: #fef4f5;
    border: ${({ theme }) => `1px solid ${theme.colors.danger700}`};
    margin-bottom: 6px;
`;

export const TagErrorIcon = styled(FontAwesomeIcon)<FontAwesomeIconProps>`
    font-size: 18px;
    padding: 8px 12px 0 4px;
    color: #e82e41;
    cursor: pointer;
`;

export const TagErrorText = styled.span`
    color: ${({ theme }) => theme.colors.danger700};
    margin-top: 4px;
    margin-right: 10px;
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
`;
